let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("hgB0d")]).then(() => parcelRequire('2DAuD'));